import React, { Component } from 'react';
import axios from 'axios';
import { Link, Redirect } from 'react-router-dom';
import { API_URL } from '../../partials/Globals';
import Errors from '../../partials/Errors';
import Message from '../../partials/Message';
import Auth from '../../../Auth';

export default class Admin extends Component {
    state = {
        admin: {
            id: '',
            first_name: '',
            last_name: '',
            phone: '',
            email: '',
            password: '',
        },
        message: '',
        errors: '',
        redirectBack: false
    }

    constructor(props) {
        super(props);

        this.inputChange = this.inputChange.bind(this);
        this.submit = this.submit.bind(this);
        this.remove = this.remove.bind(this);
    }

    componentDidMount() {
        axios.get(API_URL+'/admin/groups/admins/me')
            .then(response => {
                this.setState({ admin: {
                    id: response.data.id,
                    first_name: response.data.first_name,
                    last_name: response.data.last_name,
                    phone: response.data.phone,
                    email: response.data.email,
                    password: ''
                } });
            });
    }

    inputChange(event) {
        this.setState({ admin: {...this.state.admin, [event.target.name]: event.target.value }});
    }

    submit(event) {
        event.preventDefault();
        var self = this;

        axios.put(API_URL+'/admin/groups/admins/'+this.state.admin.id, {
            first_name: this.state.admin.first_name,
            last_name: this.state.admin.last_name,
            phone: this.state.admin.phone,
            email: this.state.admin.email,
            password: this.state.admin.password,
        })
        .then(response => {
            self.setState({ message: 'Ändringarna har sparats.' });
        })
        .catch(error => {
            // Valideringsfel
            if (error.response && error.response.status === 422) {
                self.setState({ errors: error.response.data }); 
            }
            // Annat fel
            if (error.response && error.response.status === 400) {
                self.setState({ errors: {1: 'Någonting gick fel, var god försök igen.'} })
            }
        });
    }

    remove(event) {
        event.preventDefault();
        var self = this;

        axios.delete(API_URL+'/admin/groups/admins/'+this.state.admin.id)
        .then(response => {
            Auth.logout();
        })
        .catch(error => {
            // Annat fel
            if (error.response && error.response.status === 400) {
                self.setState({ errors: {1: 'Någonting gick fel, var god försök igen.'} })
            }
        });
    }
    
    render() {
        const { admin } = this.state;

        if (this.state.redirectBack) {
            return <Redirect to="/superadmin/app" message="Administratören har tagits bort" />
        }
        
        return (
            <div>
                <div className="top">
                    <div className="col-12">
                        <button className="back" onClick={ this.props.history.goBack }>Tillbaka</button>
                    </div>
                </div>

                <Errors errors={ this.state.errors } />
                <Message message={ this.state.message } />

                <div className="container">
                    <div className="content">
                        <h1 className="m-bottom-l">Dina uppgifter</h1>

                        <form onSubmit={ this.submit }>
                            <label>Förnamn</label>
                            <input type="text" name="first_name" required value={ admin.first_name } onChange={ this.inputChange } />
                            <label>Efternamn</label>
                            <input type="text" name="last_name" required value={ admin.last_name } onChange={ this.inputChange } />
                            <label>Mobilnummer</label>
                            <input type="text" name="phone" placeholder="Mobilnummer" value={ admin.phone } onChange={ this.inputChange } />
                            <label>E-postadress</label>
                            <input type="email" name="email" placeholder="E-postadress" required value={ admin.email } onChange={ this.inputChange } />
                            <label>Nytt lösenord<br />lämna tomt för att inte byta</label>
                            <input type="password" name="password" value={ admin.password } onChange={ this.inputChange } />

                            <input className="button purple" type="submit" value="Spara" />
                        </form>

                        { (admin.groups && admin.groups.length > 0) &&
                            <div>
                                <div className="header">
                                    <h3>Grupper</h3>
                                </div>
                                    <ul>
                                        { Object.keys(admin.groups).map(function(key) {
                                            return <Link key={ key } to={ `/superadmin/groups/edit/${ admin.groups[key].id }` }>{ admin.groups[key].name }</Link>
                                        })}
                                    </ul>
                            </div>
                        }

                        <div className="danger-zone">
                            <h3>Ta bort</h3>
                            <p>Obs! Detta går inte att ångra.</p>
                            <button onClick={ this.remove }>Ta bort</button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/admin/Admin/index.js